import React from 'react';
import PropTypes from 'prop-types';

import ErrorBoundary from 'src/ErrorBoundary';

import data from 'src/data/Autopromo';
import AutopromoContainer from 'src/containers/AutopromoContainer';


const App = ({ images }) => (
  <ErrorBoundary>
    <AutopromoContainer
      data={ data }
      images={ images }
    />
  </ErrorBoundary>
);

App.propTypes = {
  images: PropTypes.shape({
    desktop1x: PropTypes.string,
    desktop2x: PropTypes.string,
    mobile1x: PropTypes.string,
    mobile2x: PropTypes.string,
    mobile3x: PropTypes.string
  })
};

App.defaultProps = {
  images: {}
};

export default App;
